import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/western-zodiac-calculator/page.tsx");
